import { spawn } from 'redux-saga/effects'
import incompleteSaga from './incomplete-listing.saga'
import listingSaga from './listing.saga'
import manageListingSaga from './manage-listing.saga'

export default function*() {
  yield [spawn(incompleteSaga), spawn(listingSaga), spawn(manageListingSaga)]
}
